/**
 * @desc 上传提单附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.customsClearance.uploadladingFile.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/uploadladingFile`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
